<template>
  <v-menu
    v-model="timePicker"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
    offset-overflow
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        ref="timeRef"
        v-model="textTime"
        prepend-icon="mdi-clock-outline"
        :disabled="disabled"
        :readonly="readonly"
        v-on="on"
        maxlength="5"
        :rules="rules"
        :clearable="!required"
        @input="inputChange"
      >
        <template v-slot:label>
          <span>{{ label }}</span>
          <span v-if="required" class="error--text"> *</span>
        </template>
      </v-text-field>
    </template>
    <v-time-picker
      v-if="timePicker"
      v-model="contactStartTime"
      @click:hour="hourClick"
      @click:minute="minuteClick"
      format="24hr"
    ></v-time-picker>
  </v-menu>
</template>

<script>
export default {
  name: "VTime",
  data() {
    return {
      timePicker: false,
      contactStartTime: "",
      textTime: "",
      fromToCheckRules: null,
      hourTime: ""
    };
  },
  model: {
    event: "selectedTime",
    prop: "actionTime"
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: "開始時刻"
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    actionTime: {
      type: String,
      default: ""
    },
    fromToCheck: {}
  },
  watch: {
    actionTime: {
      handler() {
        this.textTime = this.actionTime;
      }
    },
    timePicker: {
      handler() {
        if (this.timePicker) {
          if (this.$refs.timeRef.validate()) {
            this.contactStartTime = this.textTime;
          } else {
            this.contactStartTime = "";
          }
        }
      }
    },
    fromToCheck: {
      handler() {
        this.fromToCheckRules = this.fromToCheck;
        this.$refs.timeRef.validate(true);
      }
    }
  },
  computed: {
    rules() {
      let result = [];
      if (!this.required) {
        result = [this.$getValidate("timeFormat"), this.$getValidate("maxlength", this.label, 5)];
      } else {
        result = [
          this.$getValidate("required", this.label),
          this.$getValidate("timeFormat"),
          this.$getValidate("maxlength", this.label, 5)
        ];
      }
      if (this.fromToCheckRules) {
        result.push(this.fromToCheckRules);
      }
      return result;
    }
  },
  methods: {
    hourClick(hour) {
      if (hour < 10) {
        this.hourTime = "0" + hour;
      } else {
        this.hourTime = hour;
      }
    },
    minuteClick() {
      this.textTime = this.contactStartTime;
      this.$emit("selectedTime", this.textTime);
      this.timePicker = false;
    },
    inputChange(value) {
      if (value === "") {
        this.contactStartTime = "";
      }
      this.$emit("selectedTime", value);
    }
  },
  created() {
    if (this.actionTime) {
      this.textTime = this.actionTime;
      this.contactStartTime = this.actionTime;
      this.fromToCheckRules = this.fromToCheck;
    }
  }
};
</script>

<style></style>
